 
 
import { format } from 'd3-format';

export const DOLLAR_FORMATTER: (arg0: number) => string = format('$,.0f');
export const PERCENT_FORMATTER: (arg0: number) => string = format('.0%');
export const SM_PERCENT_FORMATTER: (arg0: number) => string = format('.2%');

export const SHORT_DOLLAR_FORMATTER = format('$.0s');
export const ALT_SHORT_DOLLAR_FORMATTER = format('$~s');
export const DECIMAL1_FORMATTER = format('.1f');
export const DECIMAL2_FORMATTER = format('.2f');
export const DECIMAL3_FORMATTER = format('.3f');
export const DECIMAL0_FORMATTER = format('.0f');
